import React, { useState } from "react";
import { postEstacion as addEstacion } from "../helpers/rutaEstaciones";
import "../css/addclienteform.css";
import { Modal } from "react-bootstrap";
import "animate.css";

const tiposEstacion = [
  "ESTACION",
  "YPF_RUTA",
  "PROVEEDOR_COMBUSTIBLE",
  "OTRO",
];

const AddEstacionForm = ({ setShow }) => {
  const [showSuccess, setShowSuccess] = useState(false);

  const initialValues = {
    codest: "",
    estacion: "",
    lugar: "",
    domicilio: "",
    telefono: "",
    cuit: "",
    tipoEstacion: "ESTACION",
    permiteCuentaCorriente: true,
    observaciones: "",
  };

  const [formValues, setFormValues] = useState(initialValues);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setFormValues({
        ...formValues,
        [name]: checked,
      });
      return;
    }

    if (["estacion", "lugar", "domicilio", "observaciones"].includes(name)) {
      setFormValues({
        ...formValues,
        [name]: value.toUpperCase(),
      });
      return;
    }

    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const limpiarFormulario = () => {
    setFormValues(initialValues);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const resp = await addEstacion(formValues);
      console.log("✅ Estación creada:", resp);

      setShowSuccess(true);

      setTimeout(() => {
        setShowSuccess(false);
        limpiarFormulario();

        // Si querés cerrar el modal al guardar:
        // if (setShow) setShow(false);
      }, 1800);
    } catch (error) {
      console.error("❌ Error al crear estación:", error);
      alert("Error al crear estación / proveedor de combustible");
    }
  };

  return (
    <>
      <div className="container">
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group mt-3 col-sm-5">
              <label>Estación / Proveedor Combustible</label>
              <input
                type="text"
                className="form-control"
                name="estacion"
                maxLength="60"
                required
                value={formValues.estacion}
                onChange={handleChange}
                placeholder="Ej: YPF BANDA DEL RÍO SALÍ"
              />
            </div>

            <div className="form-group mt-3 col-sm-4">
              <label>Lugar</label>
              <input
                type="text"
                className="form-control"
                name="lugar"
                maxLength="60"
                required
                value={formValues.lugar}
                onChange={handleChange}
                placeholder="Ej: BANDA DEL RÍO SALÍ"
              />
            </div>

            <div className="form-group mt-3 col-sm-3">
              <label>Tipo</label>
              <select
                className="form-control"
                name="tipoEstacion"
                value={formValues.tipoEstacion}
                onChange={handleChange}
                required
              >
                {tiposEstacion.map((tipo) => (
                  <option key={tipo} value={tipo}>
                    {tipo}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group mt-3 col-sm-5">
              <label>Domicilio</label>
              <input
                type="text"
                className="form-control"
                name="domicilio"
                maxLength="80"
                value={formValues.domicilio}
                onChange={handleChange}
                placeholder="Opcional"
              />
            </div>

            <div className="form-group mt-3 col-sm-3">
              <label>Teléfono</label>
              <input
                type="text"
                className="form-control"
                name="telefono"
                maxLength="30"
                value={formValues.telefono}
                onChange={handleChange}
                placeholder="Opcional"
              />
            </div>

            <div className="form-group mt-3 col-sm-3">
              <label>CUIT</label>
              <input
                type="text"
                className="form-control"
                name="cuit"
                maxLength="20"
                value={formValues.cuit}
                onChange={handleChange}
                placeholder="Opcional"
              />
            </div>

            <div className="form-group mt-4 col-sm-1 d-flex align-items-center">
              <input
                type="checkbox"
                name="permiteCuentaCorriente"
                checked={formValues.permiteCuentaCorriente}
                onChange={handleChange}
                style={{ marginRight: "6px" }}
              />
              <label style={{ marginBottom: 0, fontSize: "12px" }}>Cta.</label>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group mt-3 col-sm-12">
              <label>Observaciones</label>
              <textarea
                className="form-control"
                name="observaciones"
                rows="2"
                maxLength="200"
                value={formValues.observaciones}
                onChange={handleChange}
                placeholder="Observaciones internas"
              />
            </div>
          </div>

          <div>
            <button type="submit" className="btn btn-dark mt-4 mb-3" id="button">
              Guardar
            </button>
          </div>
        </form>
      </div>

      <Modal
        show={showSuccess}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="animate__animated animate__fadeInDown"
      >
        <Modal.Body className="text-center">
          <div style={{ fontSize: "3rem" }}>✅</div>
          <h5 className="mt-2">¡Registro generado correctamente!</h5>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddEstacionForm;